export default __webpack_public_path__ + "static/px5-0f07d792c82dffdc34ea2840cbc9710b.jpg";